export var padding = {
  paddingBottom: 4,
  paddingTop: 1
};
export var lineHeight = 20;
//# sourceMappingURL=style.js.map